export const GidSettingsRoutes = {
    ROOT: "/gid",
    ONBOARDING_LIMIT: "/gid/limit",
    ONBOARDING_LIMIT_SIGNING: "/gid/limit/signing",
    LIMIT: "/gid/limit-management",
    LIMIT_SIGNING: "/gid/limit-management/signing",
    LIMIT_SUCCESS: "/gid/limit-management/success",
    USERMANAGEMENT: "/gid/usermanagement",
    USERMANAGEMENT_USERNAME: "/gid/usermanagement/username",
    USERMANAGEMENT_USERNAME_SIGNING: "/gid/usermanagement/username-signing",
    USERMANAGEMENT_USERNAME_SUCCESS: "/gid/usermanagement/username-success",
    USERMANAGEMENT_DELETE_USERNAME_SIGNING: "/gid/usermanagement/delete-username-signing",
    USERMANAGEMENT_DELETE_USERNAME_SUCCESS: "/gid/usermanagement/delete-username-success",
    ERROR_SIGNING_METHOD: "/gid/error-signing-method"
};



// WEBPACK FOOTER //
// ./src/components/gidSettings/GidSettingsRoutes.ts